// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__iQZhK","content":"Slider_content__IC5GP","contentWrapper":"Slider_contentWrapper__UZMRC","text":"Slider_text__iuUKJ","linkBanner":"Slider_linkBanner__Anhwq"};